export enum PROFILE_FORM_TYPES {
    NONE = -1,
    EDIT_EMAIL,
    EDIT_PHONE,
    EDIT_PASSWORD,
    DELETE_PROFILE
}

export const DIALOG_WIDTH = 800;

export const DEFAULT_Z_INDEX = 900;
